module.exports = __webpack_public_path__ + "static/maj-britt-portratt-795bd7858edd77319218cb138af119b3.jpg";